const nakiRadioSystemTypes = {
    venice: "venice",
    mobile: "mobile",
    mobile_embedded: "mobile-embedded",
    mobile_restricted: "mobile-restricted",
    mobile_handheld: "mobile-handheld",
    mobile_handheld_pink: "mobile-handheld-pink",
};

export default nakiRadioSystemTypes;
